<template>
  <AuthenticatedLayout activeMenuItem='import' title='Import'>
    <PaddedLayout>
      <div class='flex flex-wrap py-2 justify-between items-center gap-2 w-full'>
        <h1 class='text-2xl'>Import</h1>
      </div>
      <form @submit.prevent='doImport' class='flex gap-2 items-end'>
        <FileInput v-model='state.files' :required='true' label='CSV File' />
        <button type="submit" class="rounded-md bg-jananavy-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-jananavy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-jananavy-600 disabled:opacity-50 disabled:hover:bg-jananavy-900" :disabled='request.isLoading() || !state.files'>
          Import
        </button>
      </form>
      <div v-if='request.isLoading()' class='px-3 py-2 bg-gray-50 rounded-md mt-4'>
        Importing...
      </div>
      <ErrorNotice v-if='request.hasError()' :error='request.getError()' class='mt-4' />
      <SuccessNotice v-if='state.completed' class='mt-4'>
        <template #title>Import complete</template>
        <template #message>
          Created Themes: {{ request.getData()?.createdThemes }}<br />
          Updated Themes: {{ request.getData()?.updatedThemes }}<br />
          Created Objectives: {{ request.getData()?.createdObjectives }}<br />
          Updated Objectives: {{ request.getData()?.updatedObjectives }}
        </template>
      </SuccessNotice>
    </PaddedLayout>
  </AuthenticatedLayout>
</template>

<script setup>

import { reactive } from 'vue';

import Papa from 'papaparse';

import AuthenticatedLayout from '@/components/layouts/authenticated-layout.vue';
import PaddedLayout from '@/components/layouts/padded-layout.vue';

import ErrorNotice from '@/components/notices/error-notice.vue';
import SuccessNotice from '@/components/notices/success-notice.vue';

import FileInput from '@/components/inputs/file-input.vue';

import { usePayloadRequest } from '@/kernel/api';

const state = reactive({
  files: null,
  completed: false
});

const request = usePayloadRequest('POST', '/objective/import');

const doImport = () => {
  if (request.isLoading()) {
    return;
  }
  
  if (!state.files) {
    return;
  }
  
  state.completed = false;
  
  const reader = new FileReader();
  
  reader.readAsText(state.files[0], "UTF-8");
  
  reader.onload = async (evt) => {
    const csv = await Papa.parse(evt.target.result);
    
    let themes = {};
    let objectives = [];
    
    const keys = {};
    
    csv.data.forEach((row, rowIndex) => {
      if (rowIndex === 0) {
        row.forEach((key, keyIdex) => {
          keys[key] = keyIdex;
        });
        
        return;
      }
      
      themes[row[keys.themeCode]] = {
        code: row[keys.themeCode],
        name: row[keys.themeName]
      }
      
      objectives.push({
        theme: row[keys.themeCode],
        code: row[keys.objectiveCode],
        version: parseInt(row[keys.version]),
        isPublished: row[keys.isPublished] === "TRUE",
        name: row[keys.name],
        objective: row[keys.objective],
        question: row[keys.question],
        guidanceNotes: row[keys.guidanceNotes],
        scoreGuideD: row[keys.scoreGuideD],
        scoreGuideC: row[keys.scoreGuideC],
        scoreGuideB: row[keys.scoreGuideB],
        scoreGuideA: row[keys.scoreGuideA],
        upliftGuideDtoC: row[keys.upliftGuideDtoC],
        upliftGuideCtoB: row[keys.upliftGuideCtoB],
        upliftGuideBtoA: row[keys.upliftGuideBtoA]
      });
    });
    
    await request.doRequest({
      body: {
        themes: Object.values(themes),
        objectives
      }
    });
    
    state.completed = true;
  }
  
}

</script>